import axios from '@/axios.js'

export default {
  fetchQuotationsVerifData ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/dashboardkpiv3')
        .then((response) => {
          commit('SET_OPERATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchQuotations ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/quotationv2/data')
        .then((response) => {
          commit('SET_OPERATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchQuotationsBroker ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/quotationv2broker/data/'+localStorage.getItem('login-broker'))
        .then((response) => {
          commit('SET_OPERATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchOperation ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/operation/data/${userId}`)
        .then((response) => {
          commit('SET_OPERATION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    }) 
  },
  updateOperation ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/operation/update', item)
        .then((response) => {
          //commit('UPDATE_USERS', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createOperation ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/operation/create', item)
        .then((response) => {
          commit('CREATE_OPERATION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchOperationProducts ({ commit },idoperation) {
    return new Promise((resolve, reject) => {
      axios.get(`/operations_products/data/`+idoperation)
        .then((response) => {
          commit('SET_OPERATIONPRODUCTS', response.data.products)
          resolve(response.data.products)
        })
        .catch((error) => { reject(error) })
    }) 
  },
  updateItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/operations_products/update', item)
        .then((response) => {
          //location.reload(); 
          commit('UPDATE_OPERATIONPRODUCTS', response.data.data.products[0])
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  createItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/operations_products/create', item)
        .then((response) => {
          commit('CREATE_OPERATIONS_PRODUCTS', Object.assign(response.data.data.products[0]))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItem ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.get("/operations_products/product/delete/" + obj.idproduct + "/" + obj.idoperation + "?who=" + encodeURIComponent(obj.who || ""))
        .then((response) => {
          //commit('REMOVE_ADDRESS', obj.idaddress)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
